import React, { useState } from 'react'
import { LayerProvider, SupportedLocale } from '@layerfi/components'
import { Outlet, useParams } from 'react-router-dom'

import { Sidebar } from '../components/Sidebar'
import { useAuth } from '../contexts/AuthContext'
import { useSidebarContext } from '../contexts/SidebarContext'
import {
  getLayerEnvironmentConfig,
  toEnvironmentConfigOverride,
} from '../layerEnvironments'
import { useLayerAccessToken } from '../useLayerAccessToken'
import { FourOhFour } from './404'
import { type DateRangeDatePickerModes } from './Admin'
import { useEnvironment } from './Environment'
import { Loading } from './Loading'

export const BusinessId = () => {
  const { businessId } = useParams()
  const { isSidebarOpen } = useSidebarContext()
  const { environment } = useEnvironment()

  const [, setImportingTransactions] = useState(false)
  const { isAdmin } = useAuth()

  const [isMobileView, setIsMobileView] = useState(false)
  const [showTooltips, setShowTooltips] = useState(false)
  const [isBookkeepingMode, setBookkeepingMode] = useState(false)
  const [showDescriptions] = useState(true)
  const [showReceiptUploads] = useState(true)
  const [showInvoicesTab] = useState(false)
  const [showCustomerVendor] = useState(false)
  const [datePickerMode] = useState<DateRangeDatePickerModes | null>(null)
  const [locale, setLocale] = useState<SupportedLocale>(SupportedLocale.enUS)
  const { data: tokenData, error: tokenError } = useLayerAccessToken(
    businessId ? `/api/environments/${environment}/businesses/${businessId}/access-token` : null,
  )

  if (!isAdmin || !businessId || (tokenError && !tokenData)) {
    return <FourOhFour />
  }

  if (!tokenData) {
    return <Loading />
  }

  return (
    <LayerProvider
      businessId={businessId}
      environmentConfigOverride={toEnvironmentConfigOverride(
        getLayerEnvironmentConfig(environment),
      )}
      businessAccessToken={tokenData.access_token}
      theme={{
        colors: {
          light: { hex: '#cccccc' },
          dark: { hex: '#000000' },
          text: { hex: '#000000' },
        },
      }}
      usePlaidSandbox={false}
      locale={locale}
    >
      <div
        className={`structure sidebar--${isSidebarOpen ? 'open' : 'closed'}`}
      >
        <Sidebar
          brandLogoUrl={
            'https://cdn.prod.website-files.com/6630b7ef13e0914488bafe32/663e0540a23f2e604ebcb1c9_Logo.svg'
          }
          demoName={'Impersonate'}
          setImportingTransactions={setImportingTransactions}
          isMobileView={isMobileView}
          setIsMobileView={setIsMobileView}
          isBookkeepingMode={isBookkeepingMode}
          setBookkeepingMode={setBookkeepingMode}
          showInvoicesTab={showInvoicesTab}
          showTooltips={showTooltips}
          setShowTooltips={setShowTooltips}
          locale={locale}
          setLocale={setLocale}
        />
        <section className='main-content'>
          <Outlet
            context={{
              businessAccessToken: tokenData.access_token,
              businessId: businessId,
              datePickerMode: datePickerMode,
              isMobileView: isMobileView,
              demoName: 'Impersonate',
              isBookkeepingMode: isBookkeepingMode,
              showDescriptions: showDescriptions,
              showReceiptUploads: showReceiptUploads,
              showInvoicesTab: showInvoicesTab,
              showCustomerVendor: showCustomerVendor,
              showTooltips: showTooltips,
            }}
          />
        </section>
      </div>
    </LayerProvider>
  )
}
